import React from 'react';
import { useForm } from 'react-hook-form';

import SearchIcon from '../../../assets/search-icon';
import Dropdown from '../../../components/dropdown';
import useGet from '../../../hook/use-get';
import { API } from '../../../helpers/constants';
import { SectionError } from '../../../components/error';

const FindTransport = ({ onSubmit, isHideTitle, defaultOrigin, defaultDestination }) => {
  const { data, isFetching, isError, refetch } = useGet({
    queryKey: 'destination',
    api: API.destinationOptions
  });

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      origin: defaultOrigin,
      destination: defaultDestination
    }
  });

  const renderContent = () => {
    if (isFetching) {
      return (
        <>
          <div className="w-full md:w-[32%] h-14 bg-gray-300 animate-pulse" />
          <div className="w-full md:w-[32%] h-14 bg-gray-300 animate-pulse" />
          <div className="w-full md:w-[32%] h-14 bg-gray-300 rounded-lg animate-pulse" />
        </>
      );
    }

    if (isError) {
      return (
        <div className="w-full items-center justify-center flex border border-b rounded-lg">
          <SectionError refetch={refetch} />
        </div>
      );
    }

    return (
      <>
        <div className="w-full md:w-[32%]">
          <Dropdown
            name="origin"
            label="Asal"
            placeholder="Masukan Asal Kota/ Kabupaten"
            values={data?.map((item) => ({
              label: item?.['destination_name'],
              value: item?.['destination_name']
            }))}
            rules={{ required: true }}
            control={control}
            error={errors.origin}
            isFindTransport
          />
        </div>
        <div className="w-full md:w-[32%]">
          <Dropdown
            name="destination"
            label="Tujuan"
            placeholder="Masukkan Tujuan Kota/ Kabupaten"
            values={data?.map((item) => ({
              label: item?.['destination_name'],
              value: item?.['destination_name']
            }))}
            rules={{ required: true }}
            control={control}
            error={errors.destination}
            isFindTransport
          />
        </div>
        <button className="flex bg-secondary-500 rounded-lg py-2 w-full md:w-[32%] justify-center items-center space-x-2">
          <SearchIcon />
          <span>Cari</span>
        </button>
      </>
    );
  };

  return (
    <form
      className="bg-white p-10 rounded-lg border border-gray-200"
      onSubmit={handleSubmit(onSubmit)}
    >
      {!isHideTitle && (
        <h2 className="text-left text-2xl md:text-3xl mb-4">Cari Jadwal Angkutan</h2>
      )}
      <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4">
        {renderContent()}
      </div>
    </form>
  );
};

export default FindTransport;
